import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { AddToCartWithAttributesPayload, Item, ItemMinimalDetails } from 'src/app/shared-core/models/cart-data.model';
import { ToastService } from 'ng-uikit-pro-standard';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CartService } from 'src/app/shared-core/services/cart.service';

declare global {
    interface Window { frequentlyBoughtTogether: any; }
}

@Component({
    selector: 'app-frequently-bought-together',
    templateUrl: './frequently-bought-together.component.html',
    styleUrls: ['./frequently-bought-together.component.scss']
})
export class FrequentlyBoughtTogetherComponent implements OnInit {
    @Input() public source: string;
    @Input() public recommendations: ItemMinimalDetails[] = [];
    @Input() isDialogMode: boolean = false;
    @ViewChild('swiper') public swiper!: ElementRef<SwiperContainer>;

    public numberOfSelected: number = 0;
    public totalPrice: number = 0;

    public selectableRecommendations: {
        isSelected: boolean,
        webCode: string,
        product: ItemMinimalDetails   
    }[] = [];

    public get recommendationsClass(): string {
        if (!this.recommendations) {
            return '';
        }

        switch(this.recommendations.length) {
            case 3:
                return 'col-xs-4 col-md-3';
            case 2:
                return 'col-xs-6 col-sm-4';
            case 1:
            default:
                return 'col-xs-6 col-sm-6';
        }
    }

    public get addRecommendationsClass(): string {
        if (!this.recommendations) {
            return '';
        }

        switch(this.recommendations.length) {
            case 3:
                return 'col-xs-12 col-md-3';
            case 2:
                return 'col-xs-12 col-sm-4';
            case 1:
            default:
                return 'col-xs-6 col-sm-6';
        }
    }

    constructor(private _cartService: CartService, private _toaster: ToastService) {
    }

    ngOnInit(): void {
        this.selectableRecommendations = this.recommendations.map(x => ({
                isSelected: true,
                webCode: x.Webcode,
                product: x
        }));

        this.calculate();
    }

    public onSelectedChange(webCode: string, isSelected: boolean) {
        this.selectableRecommendations.find(x => x.webCode == webCode).isSelected = isSelected;

        this.calculate();
    }

    public addToCart(): void {
        const payload = {
            type: 'ShoppingCart',
            source: 'Items',
            quantity: 1,
            attributes: {}
        } as AddToCartWithAttributesPayload;

        let observables: Observable<Item>[] = [];
        this.selectableRecommendations
            .forEach((i) => {
                observables.push(
                    this._cartService.addToCartWithAttributes({ ...payload, webCode: i.webCode }, this.source)
                );
            });

        forkJoin(observables)
            .pipe(
                catchError(() => {
                    this._toaster.error(
                        'An error occured adding to cart. Please try again and check the quantity.',
                        'Unable to add to cart'
                    );
                    return of(null);
                })
            )
            .subscribe((items: Item[]) => {
                if (!items || items.filter((item) => !item).length > 0) {
                    this._toaster.error('An error occured adding to cart. Please try again.', 'Unable to add to cart');
                    return;
                }

                this._toaster.success('Successfully added item' + (observables.length > 1 ? 's' : '') + ' to cart. Redirecting you to your cart.');
                window.location.href = '/cart';
            });
    }

    private calculate(): void {
        const selected = this.selectableRecommendations.filter(x => x.isSelected);
        this.numberOfSelected = selected.length;

        this.totalPrice = selected.map((i) => i.product.SellingPrice).reduce((partialSum, i) => partialSum + i, 0);
    }
}
